import React, { useMemo, useEffect } from 'react';
import { Grid, Paper } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import moment from 'moment';
import { liveTrackinglayoutSelector } from '../../../features/layout/layoutSlice';
import { useSelector } from 'react-redux';
import { useTable } from 'react-table';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useTheme } from '@mui/material/styles';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: 'Silver',
        color: useTheme().palette.common.black,
        fontSize: 13,
        fontStyle: 'bold'
    },
    body: {
        fontSize: 13,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: useTheme().palette.action.hover,
        },
    },
}))(TableRow);

/*
time: ev.eventTime,
            assetName: reportSummary.assetName,
            tankName: ev.fuel_event_tankName,
            volume: ev.fuel_event_volume,
            event_type: ev.fuel_event_type,
            lat: ev.lat,
            lng: ev.lng
*/
const FuelHighBurn = ({ reportData }) => {
    const dimentions = useSelector(liveTrackinglayoutSelector);
    const tableData = useMemo(() => {
        if (reportData.reportRecords && reportData.reportRecords.length > 0) {
            return reportData.reportRecords.map(item => {
                return {
                    vehicle: item.assetName,
                    tank: item.tankName,
                    startTime: moment(item.startTime).format('D/M/Y hh:mm A'),
                    endTime: moment(item.endTime).format('D/M/Y hh:mm A'),
                    duration: item.duration,
                    distance: `${item.distance} Km`,
                    consumed: `${item.fuelConsumed} L (${item.expectedConsumption} L)`,
                    mileage: `${item.mileage} Km/L (${item.expectedMileage} Km/L)`,
                    wastage: `${item.fuelWastage} L`,
                    key: item.assetName,
                    startLoc: item.startLoc ? item.startLoc.net_addr : '',
                    endLoc: item.endLoc ? item.endLoc.net_addr : '',
                };
            })
        } else {
            return [];
        }
    }, [reportData]);


    const tableColumns = useMemo(() => {
        return [
            { Header: 'Vehicle', accessor: 'vehicle' },
            { Header: 'Tank', accessor: 'tank' },
            { Header: 'Start Time', accessor: 'startTime' },
            { Header: 'End Time', accessor: 'endTime' },
            { Header: 'Duration', accessor: 'duration' },
            { Header: 'Distance', accessor: 'distance' },
            { Header: 'Consumed', accessor: 'consumed' },
            { Header: 'Mileage', accessor: 'mileage' },
            { Header: 'Wastage', accessor: 'wastage' },
            { Header: 'Start Location', accessor: 'startLoc' },
            { Header: 'End Location', accessor: 'endLoc' },
        ];
    }, []);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns: tableColumns, data: tableData });


    if (reportData && reportData.reportRecords && reportData.reportRecords.length > 0) {
        return (
            <Paper style={{ ...dimentions.reportDetailViewBottom, overflow: 'auto' }}>
                <div style={{ margin: '10px' }}>
                    <Grid container spacing={1}>
                        <Grid item sm={12} container>
                            <TableContainer component={Paper}>
                                <Table  {...getTableProps()}>
                                    <TableHead>
                                        {headerGroups.map(headerGroup => (
                                            <TableRow {...headerGroup.getHeaderGroupProps()}>
                                                {headerGroup.headers.map(column => (
                                                    <StyledTableCell
                                                        {...column.getHeaderProps()}
                                                    >
                                                        <b>{column.render('Header')}</b>
                                                    </StyledTableCell>
                                                ))}
                                            </TableRow>
                                        ))}
                                    </TableHead>
                                    <TableBody {...getTableBodyProps()}>
                                        {rows.map((row) => {
                                            prepareRow(row)
                                            return (
                                                <StyledTableRow {...row.getRowProps()}>
                                                    {row.cells.map(cell => {
                                                        return (
                                                            <StyledTableCell
                                                                {...cell.getCellProps()}
                                                            >
                                                                {cell.render('Cell')}
                                                            </StyledTableCell>
                                                        )
                                                    })}
                                                </StyledTableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </div>
            </Paper>
        );
    } else {
        return null;
    }
}

export default FuelHighBurn;